<template>
  <div
    class="category-search-wrapper"
    @click="show = false"
    v-if="show"
  >
    <div
      class="category-search"
      @click.stop
    >
      <div class="category-search__title">
        {{ title }}
        <div
          class="category-search__close"
          @click="show = false"
        >
          <Icon
            name="close-l"
          />
        </div>
      </div>
      <div class="category-search__content">
        <Icon
          class="category-search__icon"
          name="search-l"
        />
        <textarea
          class="category-search__input"
          ref="inputRef"
          @keyup.enter="onEnter"
          v-model.trim="search"
          enterkeyhint="search"
          placeholder="Search within category"
          type="textarea"
          :cols="2"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { buriedPointUtil } from '@/utils/utils'
import { useProductList } from '../../hooks/useProductList'
import { Icon } from '@/components/Icon'

const show = defineModel({ type: Boolean, default: false })

defineProps({
  title: {
    type: String,
    required: true
  }
})

const { filter, onReset } = useProductList()

const inputRef = useTemplateRef('inputRef')
const search = ref('')

watch(show, (val) => {
  if (val) {
    document.querySelector('body').classList.add('no-scroll')
    nextTick(() => {
      const input = inputRef.value
      if (input) {
        input.click()
        input.focus()
      }
    })
  } else {
    document.querySelector('body').classList.remove('no-scroll')
  }
})

const onEnter = () => {
  filter.keyword = search.value
  onReset()
  show.value = false
  /**
   * 业务埋点：网页Featured页面内搜索
   */
  buriedPointUtil({ eventId: 'HFS201' })
}
</script>

<style lang="less" scoped>
.category-search {
  z-index: 1000;
  position: absolute;
  top: 50%;
  left: 16px;
  right: 16px;
  transform: translateY(-50%);
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background-color: #F8F8F8;
    border: 1px solid #EBF1F5;
    font-family: mon-600;
    font-size: 14px;
    line-height: 18px;
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F5F5F5;
    border-radius: 50%;
  }

  &__content {
    display: flex;
    gap: 8px;
    padding: 16px 12px 24px;
  }

  &__icon {
    flex-shrink: 0;
    font-size: 20px;
  }

  &__input {
    padding-top: 2px;
    width: 100%;
    border: none;
    font-family: mon-500;
    font-size: 12px;

    &:focus-visible {
      outline:  none;
    }
  }

  &-wrapper {
    z-index: 999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(8px);
  }
}
</style>
